<template>
  <div style="width: 100%">
    <!-- Game Iframe -->
    <div
      v-if="gameErrorSession"
      :style="{
        width: '100%',
        height: '718px',
        backgroundImage: gameData
          ? `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
          url(https://cdn.softswiss.net/b/${
            gameData.identifier_game.split(':')[0]
          }/${gameData.identifier_game.split(':')[1]}.jpg)`
          : '',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }"
    >
      <div class="errorIframe">
        <div class="svgIcon mr-13">
          <SvgIcon svgId="errorGameDesktop" />
        </div>
        <h6 class="error-message">
          {{ $t("gameNotAvailable") }}
          <br />
          {{ $t("pleaseTryAgainLater") }}
        </h6>
      </div>
    </div>

    <div
      v-else-if="!$store.state.logged.status && gameData"
      :style="{
        width: '100%',
        height: '600px',
        backgroundImage: gameData
          ? `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
          url(https://cdn.softswiss.net/b/${
            gameData.identifier_game.split(':')[0]
          }/${gameData.identifier_game.split(':')[1]}.jpg)`
          : '',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }"
    >
      <div
        class="d-flex flex-column align-center"
        style="gap: 12px"
        v-if="gameData"
      >
        <v-img
          v-if="imageError === false"
          :src="gameData.src"
          eager
          max-width="35%"
          @error="imageError = true"
          style="
                border-radius: 2rem;
                -webkit-box-shadow: 10px 10px 20px 5px #000000;
                box-shadow: 0px 32px 40px 1px rgba(0, 0, 0, 0.5);
              "
        >
          <template v-slot:placeholder>
            <div class="d-flex align-center justify-center fill-height">
              <v-progress-circular
                color="grey-lighten-4"
                indeterminate
              ></v-progress-circular>
            </div>
          </template>
        </v-img>

        <div
          v-html="
            $t('newCasino.unloggedAtGame', {
              game: gameData && gameData.title_game,
            })
          "
          class="text-h6 mt-8"
        ></div>
        <div class="d-flex align-center">
          <DialogRegister idDialog="desktopGame" />
          <Login />
        </div>
      </div>
    </div>

    <div
      v-else-if="!loading && $store.state.logged.status"
      id="game_wrapper"
      width="90%"
      :style="
        `
        height: ${
          modeViewGame === 'theater'
            ? 'calc(100vh - 228px)'
            : modeViewGame === 'fullscreen'
            ? '100%'
            : 'calc(100vh - 127px)'
        };
        max-height: ${
          modeViewGame === 'theater'
            ? ''
            : modeViewGame === 'fullscreen'
            ? '90%'
            : '718px'
        };
        display: ${
          $store.state.logged.status ? loading : !gameData ? 'none' : 'block'
        };
        overflow: none; border: none; background-color: transparent; ${
          modeViewGame === 'fullscreen'
            ? 'position:fixed; top:0; left:0; bottom:0; right:0; width:100%; height:100%; border:none; margin:0; padding:0; overflow:hidden; z-index:999999;'
            : 'z-index: 201;'
        }`
      "
    ></div>

    <!-- Footer Game - Fullscreen -->
    <div
      v-if="modeViewGame === 'fullscreen'"
      class="d-flex justify-center align-center py-4 px-6 justify-space-between colorDominant"
      :style="{
        overflow: 'none',
        border: 'none',
        backgroundColor: 'transparent',
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        width: '100%',
        height: '10%',
        margin: 0,
        padding: 0,
        zIndex: 999999,
      }"
    >
      <!-- Image Provider -->
      <img
        v-if="gameData && gameData.src"
        class="mr-6"
        width="60px"
        :src="gameData.src"
        style="border-radius: 1rem;"
      />

      <div class="d-flex flex-column" style="width: 100%">
        <h5 style="font-size: 1.2rem; line-height: 1.1rem">
          {{ gameData.title_game }}
          <v-btn
            v-if="$store.state.logged.status"
            icon
            @click="handleGameFavorite(gameData)"
          >
            <v-icon size="24">{{ btnFavoriteConfig.icon }}</v-icon>
          </v-btn>
        </h5>
        <h6
          @click="allGamesProvider(gameData.id_provider)"
          style="
            color: #ccc;
            font-weight: 400;
            font-size: 0.9rem;
            text-transform: capitalize;
            cursor: pointer;
          "
        >
          {{ gameData.name_provider }}
        </h6>
      </div>

      <v-tooltip
        v-for="option in viewOptions"
        :key="option.value"
        top
        style="z-index: 202"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            dark
            icon
            :color="option.value === modeViewGame ? 'primary' : ''"
            @click="setModeViewGame(option.value)"
            :disabled="!$store.state.logged.status"
          >
            <v-icon>
              {{
                option.value === modeViewGame
                  ? option.activeIcon
                  : option.inactiveIcon
              }}
            </v-icon>
          </v-btn>
        </template>
        <span>
          {{ option.text }}
        </span>
      </v-tooltip>
    </div>

    <v-skeleton-loader
      v-if="loading || (!gameData && !$store.state.logged.status)"
      type="image"
      :style="
        `
          height: 718px;
          width: 100%;
          display: ${
            loading || (!gameData && !$store.state.logged.status)
              ? 'block'
              : 'none'
          };
        `
      "
    />

    <!-- Footer Game - No fullscreen -->
    <div
      class="d-flex justify-center align-center py-4 px-6 justify-space-between colorDominant"
      :style="`height:auto; width: 100%;`"
    >
      <!-- Image Provider -->
      <img
        v-if="gameData && gameData.src"
        class="mr-6"
        width="60px"
        :src="gameData.src"
        style="border-radius: 1rem;"
      />

      <div class="d-flex flex-column" style="width: 100%">
        <h5
          style="font-size: 1.2rem; line-height: 1.1rem"
          v-if="!loading && gameData"
        >
          {{ gameData.title_game }}
          <v-btn
            v-if="$store.state.logged.status"
            icon
            @click="handleGameFavorite(gameData)"
          >
            <v-icon size="24">{{ btnFavoriteConfig.icon }}</v-icon>
          </v-btn>
        </h5>
        <h5
          style="font-size: 1.2rem; line-height: 1.1rem"
          v-else-if="
            gameData && gameData.title_game && !$store.state.logged.status
          "
        >
          {{ gameData.title_game }}
          <v-btn
            v-if="$store.state.logged.status"
            icon
            @click="handleGameFavorite(gameData)"
          >
            <v-icon size="24">{{ btnFavoriteConfig.icon }}</v-icon>
          </v-btn>
        </h5>
        <v-skeleton-loader v-else width="150px" type="text"></v-skeleton-loader>
        <h6
          v-if="!loading && gameData"
          style="
            color: #ccc;
            font-weight: 400;
            font-size: 0.9rem;
            text-transform: capitalize;
          "
        >
          {{ gameData.name_provider }}
        </h6>
        <h6
          v-else-if="
            gameData && gameData.name_provider && !$store.state.logged.status
          "
          style="
            color: #ccc;
            font-weight: 400;
            font-size: 0.9rem;
            text-transform: capitalize;
            cursor: pointer;
          "
        >
          {{ gameData.name_provider }}
        </h6>
        <v-skeleton-loader v-else width="75px" type="text"></v-skeleton-loader>
      </div>
      <v-tooltip
        top
        style="z-index: 202"
        v-for="option in viewOptions"
        :key="option.value"
      >
        <template v-if="!gameErrorSession" v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            dark
            icon
            :color="option.value === modeViewGame ? 'primary' : ''"
            @click="setModeViewGame(option.value)"
            :disabled="loading || !$store.state.logged.status"
          >
            <v-icon>
              {{
                option.value === modeViewGame
                  ? option.activeIcon
                  : option.inactiveIcon
              }}
            </v-icon>
          </v-btn>
        </template>
        <span>
          {{ option.text }}
        </span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import SvgIcon from "../SvgIcon.vue";
import Login from "@/components/login/dialog.vue";
import DialogRegister from "@/views/home/register/dialog-register";
import {
  isGameFavorite,
  addGameFavorite,
  removeGameFavorite
} from "@/util/casino/gameFavorite.js";

export default {
  components: {
    SvgIcon,
    Login,
    DialogRegister,
  },
  name: "DesktopGame",

  props: ["loading", "gameUrl", "gameData", "status"],

  data: (vm) => ({
    imageError: false,
    viewOptions: [
      {
        text: vm.$t("theaterMode"),
        value: "theater",
        inactiveIcon: "mdi-rectangle-outline",
        activeIcon: "mdi-rectangle-outline",
      },
      {
        text: vm.$t("fullscreen"),
        value: "fullscreen",
        inactiveIcon: "mdi-fullscreen",
        activeIcon: "mdi-fullscreen-exit",
      },
    ],
    btnFavoriteConfig: { icon: "" },
  }),

  mounted() {
    this.updateBtnFavoriteConfig();
  },

  watch: {
    gamesFavoritesUpdating() {
      this.updateBtnFavoriteConfig();
    },
    gameData() {
      this.updateBtnFavoriteConfig();
    },
    "$store.state.logged.status"() {
      this.updateBtnFavoriteConfig();
    },
  },

  computed: {
    gameErrorSession() {
      return this.status === 400;
    },
    modeViewGame() {
      return this.$store.state.modeViewGame;
    },
    casinoType() {
      return this.$route.params.casinoType;
    },
    gamesFavoritesUpdating() {
      return this.$store.state.gamesFavoritesUpdating;
    },
  },

  methods: {
    setModeViewGame(mode) {
      if (this.modeViewGame === mode) {
        this.$store.commit("setModeViewGame", "");
      } else {
        this.$store.commit("setModeViewGame", mode);
      }
    },
    allGamesProvider(providerId) {
      this.$router.push({
        name: "casinoProvider",
        params: { providerId },
      });
    },
    updateBtnFavoriteConfig() {
      const btnConfig = {
        0: { icon: "mdi-star-outline" },
        1: { icon: "mdi-star-check" },
      };

      this.btnFavoriteConfig =
        btnConfig[isGameFavorite(this.casinoType, this.gameData.key)];
    },
    handleGameFavorite(game) {
      if (isGameFavorite(this.casinoType, game.key)) {
        removeGameFavorite(this.casinoType, game.key);
      } else {
        addGameFavorite(this.casinoType, game);
      }
    },
  },
};
</script>

<style>
.v-skeleton-loader__image {
  height: 100% !important;
}

#game_wrapper {
  width: 100%;
}

#game_wrapper iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.error-message {
  color: #ccc;
  font-weight: 400;
  font-size: 1.5rem;
  font-family: Roboto;
  text-align: center;
  margin-top: 50px;
  width: 75%;
  padding-bottom: 100px;
}

.errorIframe {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
}

.svgIcon {
  padding-top: 100px;
}

svg path {
  fill: #ccc;
}
</style>
